import { createAppSlice } from "../../app/createAppSlice";
import type { AppThunk } from "../../app/store";
import { ng } from "@common/ngds";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
export const getConfig = createAction<number>("api/users");

export type configState = {
  config: any | null;
  status: "idle" | "loading" | "failed";
};

export const fetchConfig = createAsyncThunk("config/config", async () => {
  const resp = await fetch(`/api/config/`);
  let a = await resp.json();
  return a;
});

export function useConfig() {
  const dispatch = useAppDispatch();

  const fetchConfigData = () => {
    dispatch(fetchConfig());
  };

  return [fetchConfigData] as const;
}

const initialState: configState = {
  config: null,
  status: "idle",
};

export const ConfigSlice = createAppSlice({
  name: "configSlice",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchConfig.pending, () => {});
    builder.addCase(fetchConfig.fulfilled, (state, action) => {
      state.config = action.payload;
    });
  },
  selectors: {
    selectConfig: (state) => state.config,
  },
});

export const { selectConfig } = ConfigSlice.selectors;

export const useDevConfig = (): boolean => {
  const config = useAppSelector(selectConfig);
  return config?.IS_DEV ?? false;
};
